import { DataSyncRunSchema } from '../../shared/data-sync';
export const showDataSyncRunContract = {
    method: 'GET',
    path: '/api/v2/data-sync/runs/:id',
    description: 'Show a sync run with its differences and outcomes',
    responseSchema: DataSyncRunSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - not allowed to manage the data source',
            404: 'Not Found - sync run not found'
        }
    }
};

//# sourceMappingURL=show-data-sync-run.contract.js.map